import * as aggr from '@/api-generator/aggr'
import { ORG_SORT_TAG_COLORS } from '@/constant/client/orgSortTag'
import appStore from '@/stores'

/**
 * 根據標籤順序取得對應的顏色
 * @param order 標籤順序（從 0 開始）
 * @returns 顏色值（hex 格式）
 */
export const getTagColor = (order: number): string => {
  return ORG_SORT_TAG_COLORS[order % ORG_SORT_TAG_COLORS.length]
}

export const useOrgSortTagStyle = () => {
  const orgSortTagStore = appStore.useOrgSortTagStore

  /**
   * 取得組織分類標籤顏色樣式
   * @param row 組織分類標籤資料列
   * @returns 顏色樣式物件
   */
  const getOrgSortTagStyle = (row: aggr.FEUrlGroupingQueryAllRs) => {
    if (!orgSortTagStore.orgSortTags || row.orgTagId === undefined) {
      return {
        style: null
      }
    }

    const tag = orgSortTagStore.orgSortTags.find((t) => t.orgTagId === row.orgTagId)

    if (tag?.order !== undefined && typeof tag.order === 'number') {
      return {
        style: {
          backgroundColor: getTagColor(tag.order)
        }
      }
    }

    return {
      style: null
    }
  }

  return {
    getOrgSortTagStyle,
    getTagColor
  }
}
